<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator="/" style="margin-bottom: 15px">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>督导主管</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片视图区 -->
    <el-card class="box-card" style="margin-top: 15px">
      <div slot="header" class="flexContainer">
        <span class="cardHeader">督导主管工作台</span>
        <el-checkbox v-model="tableDrag" style="float: right">表格拖拽</el-checkbox>
      </div>

      <!-- 标签页 -->
      <el-tabs v-model="activeTab" @tab-click="handleTabClick">

        <!-- ==================== 周新增统计 ==================== -->
        <el-tab-pane label="周新增统计" name="weekly">
          <el-table
            :data="weeklyList"
            border
            stripe
            v-loading="weeklyLoading"
            v-drag-scroll="tableDrag"
          >
            <!-- 筹建督导 -->
            <el-table-column prop="supervisorName" label="筹建督导" fixed="left" width="100"></el-table-column>

            <!-- 人效 -->
            <el-table-column prop="building" label="人效" align="center" width="100"></el-table-column>

            <!-- 筹建中门店总数 -->
            <el-table-column prop="building" align="center" width="140">
              <template slot="header">
                <el-tooltip content="筹建流程未完成的门店数" placement="top">
                  <span>筹建中门店数 <i class="el-icon-question"></i></span>
                </el-tooltip>
              </template>
            </el-table-column>

            <!-- 接收门店数 -->
            <el-table-column label="接收门店数">
              <el-table-column prop="lastWeekReceived" label="上周" width="80" align="center"></el-table-column>
              <el-table-column prop="thisWeekReceived" label="本周" width="80" align="center"></el-table-column>
            </el-table-column>

            <!-- 待运营门店数 -->
            <!-- <el-table-column label="待运营门店数">
              <el-table-column prop="lastWeekPendingOperation" label="上周" width="80" align="center"></el-table-column>
              <el-table-column prop="thisWeekPendingOperation" label="本周" width="80" align="center"></el-table-column>
            </el-table-column> -->

            <!-- 开业门店数 -->
            <el-table-column label="">
              <template slot="header">
                <el-tooltip content="开业时间在本周的门店数" placement="top">
                  <span>开业门店数 <i class="el-icon-question"></i></span>
                </el-tooltip>
              </template>
              <el-table-column prop="lastWeekOpened" label="上周" width="80" align="center"></el-table-column>
              <el-table-column prop="thisWeekOpened" label="本周" width="80" align="center"></el-table-column>
            </el-table-column>

            <!-- 公司培训门店数 -->
            <el-table-column label="公司培训门店数">
              <el-table-column prop="lastWeekCompanyTrainingComplete" label="上周" width="80" align="center"></el-table-column>
              <el-table-column prop="thisWeekCompanyTrainingComplete" label="本周" width="80" align="center"></el-table-column>
            </el-table-column>

            <!-- 实操培训门店数 -->
            <el-table-column label="实操培训门店数">
              <el-table-column prop="lastWeekPracticalTrainingComplete" label="上周" width="80" align="center"></el-table-column>
              <el-table-column prop="thisWeekPracticalTrainingComplete" label="本周" width="80" align="center"></el-table-column>
            </el-table-column>
          </el-table>

          <br/>

          <el-table
            :data="operationWeeklyList"
            border
            stripe
            v-loading="operationMonthlyLoading"
            v-drag-scroll="tableDrag"
          >
            <!-- 营运督导 -->
            <el-table-column prop="supervisorName" label="营运督导" fixed="left" width="100"></el-table-column>

            <!-- 人效 -->
            <el-table-column label="人效" align="center" width="100">
              <template slot-scope="scope">
                {{scope.row.openingTotal+scope.row.waitingTotal}}
              </template>
            </el-table-column>

            <!-- 营业中门店总数 -->
            <el-table-column prop="openingTotal" align="center" width="140">
              <template slot="header">
                <el-tooltip content="已到开业时间的门店数" placement="top">
                  <span>营业中门店数 <i class="el-icon-question"></i></span>
                </el-tooltip>
              </template>
            </el-table-column>

            <!-- 未营业门店总数 -->
            <el-table-column prop="waitingTotal" align="center" width="140">
              <template slot="header">
                <el-tooltip content="已分配营运督导和运营师，但未设置开业时间或未到开业时间的门店数" placement="top">
                  <span>未营业门店数 <i class="el-icon-question"></i></span>
                </el-tooltip>
              </template>
            </el-table-column>

          </el-table>
        </el-tab-pane>

        <!-- ==================== 月新增统计 ==================== -->
        <el-tab-pane label="月新增统计" name="monthly">
          <!-- 搜索条 -->
          <div style="margin-bottom: 15px">
            <el-date-picker
              v-model="monthlyMonth"
              type="month"
              placeholder="选择月份"
              value-format="yyyy-MM"
              @change="getMonthlyStats"
              size="small"
            ></el-date-picker>
          </div>

          <el-table
            :data="monthlyList"
            border
            stripe
            v-loading="monthlyLoading"
            v-drag-scroll="tableDrag"
          >
            <!-- 筹建督导 -->
            <el-table-column prop="supervisorName" label="筹建督导" fixed="left" width="100"></el-table-column>

            <!-- 人效 -->
            <el-table-column prop="building" label="人效" align="center" width="100"></el-table-column>

            <!-- 筹建中门店总数 -->
            <el-table-column prop="building" align="center" width="140">
              <template slot="header">
                <el-tooltip content="筹建流程未完成的门店数" placement="top">
                  <span>筹建中门店数 <i class="el-icon-question"></i></span>
                </el-tooltip>
              </template>
            </el-table-column>

            <!-- 接收门店数 -->
            <el-table-column label="接收门店数">
              <el-table-column prop="lastMonthReceived" label="上月" width="80" align="center"></el-table-column>
              <el-table-column prop="thisMonthReceived" label="本月" width="80" align="center"></el-table-column>
            </el-table-column>

            <!-- 待运营门店数 -->
            <!-- <el-table-column label="待运营门店数">
              <el-table-column prop="lastMonthPendingOperation" label="上月" width="80" align="center"></el-table-column>
              <el-table-column prop="thisMonthPendingOperation" label="本月" width="80" align="center"></el-table-column>
            </el-table-column> -->

            <!-- 开业门店数 -->
            <el-table-column label="">
              <template slot="header">
                <el-tooltip content="开业时间在本月的门店数" placement="top">
                  <span>开业门店数 <i class="el-icon-question"></i></span>
                </el-tooltip>
              </template>
              <el-table-column prop="lastMonthOpened" label="上月" width="80" align="center"></el-table-column>
              <el-table-column prop="thisMonthOpened" label="本月" width="80" align="center"></el-table-column>
            </el-table-column>

            <!-- 公司培训门店数 -->
            <el-table-column label="公司培训门店数">
              <el-table-column prop="lastMonthCompanyTrainingComplete" label="上月" width="80" align="center"></el-table-column>
              <el-table-column prop="thisMonthCompanyTrainingComplete" label="本月" width="80" align="center"></el-table-column>
            </el-table-column>

            <!-- 实操培训门店数 -->
            <el-table-column label="实操培训门店数">
              <el-table-column prop="lastMonthPracticalTrainingComplete" label="上月" width="80" align="center"></el-table-column>
              <el-table-column prop="thisMonthPracticalTrainingComplete" label="本月" width="80" align="center"></el-table-column>
            </el-table-column>
          </el-table>

          <br/>

          <el-table
            :data="operationMonthlyList"
            border
            stripe
            v-loading="operationMonthlyLoading"
            v-drag-scroll="tableDrag"
          >
            <!-- 营运督导 -->
            <el-table-column prop="supervisorName" label="营运督导" fixed="left" width="100"></el-table-column>

            <!-- 人效 -->
            <el-table-column label="人效" align="center" width="100">
              <template slot-scope="scope">
                {{scope.row.openingTotal+scope.row.waitingTotal}}
              </template>
            </el-table-column>

            <!-- 营业中门店总数 -->
            <el-table-column prop="openingTotal" align="center" width="140">
              <template slot="header">
                <el-tooltip content="已到开业时间的门店数" placement="top">
                  <span>营业中门店数 <i class="el-icon-question"></i></span>
                </el-tooltip>
              </template>
            </el-table-column>

            <!-- 未营业门店总数 -->
            <el-table-column prop="waitingTotal" align="center" width="140">
              <template slot="header">
                <el-tooltip content="已分配营运督导和运营师，但未设置开业时间或未到开业时间的门店数" placement="top">
                  <span>未营业门店数 <i class="el-icon-question"></i></span>
                </el-tooltip>
              </template>
            </el-table-column>

          </el-table>
        </el-tab-pane>

        <!-- ==================== 筹建统计 ==================== -->
        <el-tab-pane label="筹建统计" name="summary">
          <!-- 搜索条 -->
          <div style="margin-bottom: 15px">
            <el-date-picker
              v-model="summaryDateRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              @change="getSummaryStats"
              size="small"
            ></el-date-picker>
          </div>

          <el-table
            :data="summaryList"
            border
            stripe
            v-loading="summaryLoading"
            v-drag-scroll="tableDrag"
          >
            <!-- 筹建督导 -->
            <el-table-column prop="supervisorName" label="筹建督导" fixed="left" width="100"></el-table-column>

            <!-- 汇总统计列 -->
            <el-table-column prop="pendingCount" label="待收门店数" width="100" align="center" fixed="left"></el-table-column>
            <el-table-column prop="receivedCount" label="接收门店数" width="100" align="center" fixed="left"></el-table-column>
            <el-table-column prop="buildingCount" label="筹建门店数" width="100" align="center" fixed="left"></el-table-column>
            <el-table-column prop="completedCount" label="完成门店数" width="100" align="center" fixed="left"></el-table-column>

            <!-- 21个节点列 -->
            <el-table-column prop="FIRST_COMMUNICATION" label="首次沟通" width="100" align="center"></el-table-column>
            <el-table-column prop="DOOR_DESIGN_END" label="门头设计" width="100" align="center"></el-table-column>
            <el-table-column prop="LAYOUT_DESIGN_END" label="动线设计" width="100" align="center"></el-table-column>
            <el-table-column prop="COMPANY_TRAINING_BOOK" label="预约公司培训" width="110" align="center"></el-table-column>
            <el-table-column prop="COMPANY_TRAINING_COMPLETE" label="公司培训" width="100" align="center"></el-table-column>
            <el-table-column prop="EQUIPMENT_LIST" label="设备清单" width="100" align="center"></el-table-column>
            <el-table-column prop="MATERIAL_LIST" label="食材包材清单" width="110" align="center"></el-table-column>
            <el-table-column prop="MEITUAN_ORDER_REGISTER" label="订货注册" width="100" align="center"></el-table-column>
            <el-table-column prop="FIRST_BATCH_REVIEW" label="首批审核" width="100" align="center"></el-table-column>
            <el-table-column prop="BUSINESS_LICENSE" label="营业执照" width="100" align="center"></el-table-column>
            <el-table-column prop="FOOD_LICENSE" label="餐饮许可证" width="110" align="center"></el-table-column>
            <el-table-column prop="ONLINE_CHECK" label="线上检查" width="100" align="center"></el-table-column>
            <el-table-column prop="CAMERA_SHARE" label="摄像头分享" width="110" align="center"></el-table-column>
            <el-table-column prop="PRACTICAL_TRAINING_BOOK" label="预约实操培训" width="110" align="center"></el-table-column>
            <el-table-column prop="PRACTICAL_TRAINING_COMPLETE" label="实操培训" width="100" align="center"></el-table-column>
            <el-table-column prop="PRODUCT_AUDIT" label="出品审核" width="100" align="center"></el-table-column>
            <el-table-column prop="DATA_COLLECT" label="建店资料收集" width="110" align="center"></el-table-column>
            <el-table-column prop="ACCOUNT_CREATE" label="账号创建" width="100" align="center"></el-table-column>
            <el-table-column prop="MANAGEMENT_AGREEMENT" label="管理协议" width="100" align="center"></el-table-column>
            <el-table-column prop="STORE_OPENING" label="预约开业" width="100" align="center"></el-table-column>
            <el-table-column prop="PRODUCT_REVIEW" label="产品审核" width="100" align="center"></el-table-column>
          </el-table>
        </el-tab-pane>

      </el-tabs>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'DudaoZhuguan',
  data () {
    return {
      activeTab: 'weekly',
      tableDrag: true,
      // 周统计数据
      weeklyList: [],
      weeklyLoading: false,
      operationWeeklyList: [],
      operationWeeklyLoading: false,
      // 月统计数据
      monthlyList: [],
      monthlyLoading: false,
      monthlyMonth: '',
      operationMonthlyList: [],
      operationMonthlyLoading: false,
      // 筹建统计数据
      summaryList: [],
      summaryLoading: false,
      summaryDateRange: null
    }
  },
  created () {
    // 页面加载时获取周新增统计
    this.getWeeklyStats()
    this.getOperationWeeklyStats()
  },
  methods: {
    /** 标签页切换事件 */
    handleTabClick (tab) {
      if (tab.name === 'weekly') {
        this.getWeeklyStats()
        this.getOperationWeeklyStats()
      } else if (tab.name === 'monthly') {
        this.getMonthlyStats()
        this.getOperationMonthlyStats()
      } else if (tab.name === 'summary') {
        this.getSummaryStats()
      }
    },

    /** 获取周新增统计 */
    async getWeeklyStats () {
      this.weeklyLoading = true
      try {
        const { data: res } = await this.$http.get('process/supervisor/weeklyStats')
        if (res.meta.status !== 200) {
          return this.$message.error(res.meta.msg)
        }
        this.weeklyList = res.data.list
      } catch (err) {
        this.$message.error('获取周新增统计失败')
      } finally {
        this.weeklyLoading = false
      }
    },

    async getOperationWeeklyStats () {
      this.operationWeeklyLoading = true
      try {
        const { data: res } = await this.$http.get('process/supervisor/operationWeeklyStats')
        if (res.meta.status !== 200) {
          return this.$message.error(res.meta.msg)
        }
        this.operationWeeklyList = res.data.list
      } catch (err) {
        this.$message.error('获取周新增统计失败')
      } finally {
        this.operationWeeklyLoading = false
      }
    },

    /** 获取月新增统计 */
    async getMonthlyStats () {
      this.monthlyLoading = true
      try {
        const params = {}
        if (this.monthlyMonth) {
          params.month = this.monthlyMonth
        }
        const { data: res } = await this.$http.get('process/supervisor/monthlyStats', { params })
        if (res.meta.status !== 200) {
          return this.$message.error(res.meta.msg)
        }
        this.monthlyList = res.data.list
      } catch (err) {
        this.$message.error('获取月新增统计失败')
      } finally {
        this.monthlyLoading = false
      }
    },

    async getOperationMonthlyStats () {
      this.monthlyLoading = true
      try {
        const params = {}
        if (this.monthlyMonth) {
          params.month = this.monthlyMonth
        }
        const { data: res } = await this.$http.get('process/supervisor/operationMonthlyStats', { params })
        if (res.meta.status !== 200) {
          return this.$message.error(res.meta.msg)
        }
        this.operationMonthlyList = res.data.list
      } catch (err) {
        this.$message.error('获取月新增统计失败')
      } finally {
        this.operationMonthlyLoading = false
      }
    },

    /** 获取筹建统计 */
    async getSummaryStats () {
      this.summaryLoading = true
      try {
        const params = {}
        if (this.summaryDateRange && this.summaryDateRange.length === 2) {
          params.startDate = this.summaryDateRange[0]
          params.endDate = this.summaryDateRange[1]
        }
        const { data: res } = await this.$http.get('process/supervisor/summaryStats', { params })
        if (res.meta.status !== 200) {
          return this.$message.error(res.meta.msg)
        }
        this.summaryList = res.data.list
      } catch (err) {
        this.$message.error('获取筹建统计失败')
      } finally {
        this.summaryLoading = false
      }
    }
  }
}
</script>

<style scoped>
</style>
